// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTitle_container__1yg1I","inner":"PageTitle_inner__1B2Xy"};